module.exports = __webpack_public_path__ + "img/winery_afternoon_tea1.44bfbb34.png";